import { render, staticRenderFns } from "./categories-filter-form.vue?vue&type=template&id=49c645e9&"
import script from "./categories-filter-form.vue?vue&type=script&lang=ts&"
export * from "./categories-filter-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports